import React from 'react';
import firstImage from './assets/image 1.png';
import secondImage from './assets/image 4.png';

function App() {
  return (
    <div style={styles.app}>
      {/* الصورة الأولى */}
      <div style={styles.imageContainer}>
        <img 
          src={firstImage} 
          alt="First Logo" 
          style={styles.firstImage}
        />
      </div>
      
      {/* الصورة الثانية */}
      <div style={styles.imageContainer}>
        <img 
          src={secondImage} 
          alt="Second Logo" 
          style={styles.secondImage}
        />
      </div>
      
      {/* النص الأول */}
      <div style={styles.textContainer}>
        <h1 style={styles.underConstruction}>
          Our Website Is Under Construction
        </h1>
      </div>
      
      {/* النص الثاني */}
      <div style={styles.textContainer}>
        <h2 style={styles.seeYouSoon}>
          See You Soon ..
        </h2>
      </div>
    </div>
  );
}

const styles = {
  app: {
    minHeight: '100vh',
    maxHeight: '100vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#ffffff',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    boxSizing: 'border-box'
  },
  
  imageContainer: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    width: '100%',
    height: 'auto'
  },
  
  firstImage: {
    width: '180px',
    height: '140px',
    objectFit: 'contain',
    opacity: 1
  },
  
  secondImage: {
    width: '240px',
    height: '274px',
    objectFit: 'contain',
    opacity: 1,
    marginBottom: '10px'
  },
  
  textContainer: {
    marginBottom: '10px',
    width: '100%',
    maxWidth: '869px',
    flexShrink: 0
  },
  
  underConstruction: {
    width: '100%',
    maxWidth: '869px',
    height: 'auto',
    minHeight: '66px',
    fontFamily: "'Georgia', 'Times New Roman', serif",
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '32px',
    lineHeight: '138%',
    letterSpacing: '0%',
    textAlign: 'center',
    color: '#000000',
    margin: '0 auto 5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px'
  },
  
  seeYouSoon: {
    width: '100%',
    maxWidth: '869px',
    height: 'auto',
    minHeight: '48px',
    fontFamily: "'Arial Black', 'Impact', sans-serif",
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '32px',
    lineHeight: '119%',
    letterSpacing: '0%',
    textAlign: 'center',
    background: 'linear-gradient(90deg, #966830 0%, #B08434 100%)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px'
  }
};

export default App;